import React from 'react';
import { FormattedMessage } from 'react-intl';

export const priceAlertColumns = {
  name: {
    id: 'name',
    label: <FormattedMessage id={'app.pricealert.name'} />,
    width: '20%',
    options: {},
  },
  contract: {
    id: 'contract',
    label: <FormattedMessage id={'app.pricealert.contract'} />,
    options: {},
  },
  product: {
    id: 'product',
    label: <FormattedMessage id={'app.pricealert.product'} />,
    options: {},
  },
  type: {
    id: 'type',
    label: <FormattedMessage id={'app.pricealert.type'} />,
    options: {},
  },
  warningType: {
    id: 'warningType',
    label: <FormattedMessage id={'app.pricealert.warningType'} />,
    options: {},
  },
  minPrice: {
    id: 'minPrice',
    label: <FormattedMessage id={'app.pricealert.minPrice'} />,
    align: 'right',
    options: {},
  },
  maxPrice: {
    id: 'maxPrice',
    label: <FormattedMessage id={'app.pricealert.maxPrice'} />,
    align: 'right',
    options: {},
  },
};
